import { EmptyView } from "@/components/view";
import { useTranslation } from "@/hooks";
import { useDatabaseStore } from "@/stores/database";
import { useDataflowStore } from "@/stores/dataflow";
import { useUIStore } from "@/stores/ui";
import { useEffect, useMemo } from "react";
import { Navigate } from "react-router";

export function BuildPage() {
  const { t } = useTranslation();
  const projects = useDatabaseStore((state) => state.projects);
  const lastOpenedProjectId = useDataflowStore(
    (state) => state.lastOpenedProjectId
  );
  const setActiveDataflow = useDataflowStore(
    (state) => state.setActiveDataflow
  );
  const openModal = useUIStore((state) => state.openModal);

  const defaultProject = useMemo(() => {
    const lastOpenedProject = lastOpenedProjectId
      ? projects.find((p) => p.id === lastOpenedProjectId)
      : null;
    return lastOpenedProject ?? projects[0];
  }, [projects, lastOpenedProjectId]);

  useEffect(() => {
    setActiveDataflow(null);
  }, [setActiveDataflow]);

  if (projects.length === 0) {
    return (
      <EmptyView
        title={t("projects").noProjects}
        height="60vh"
        description={t("projects").noProjectsDescription}
        button={{
          label: t("projects").createNewProject,
          onClick: () => openModal(undefined, "project"),
        }}
      />
    );
  }

  return <Navigate to={`/build/${defaultProject.id}`} />;
}
